"use client";

import React, { useState } from "react";
import { Box, Button, Card, Chip, Grow, Icon, IconButton, LinearProgress, Stack, SwipeableDrawer, Typography } from "@mui/material";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import { Close } from "@mui/icons-material";
import { Color } from "@/__generated__/sdk";
import { useSiteSearchContext } from "./SiteSearchContext";
import _ from "lodash";

export default function MobileFilterInStockChip() {
  const { isPending, inStock, handleInStockChange } = useSiteSearchContext();
  return (
    <>
      <Chip
        variant={inStock ? "filled" : "outlined"}
        onClick={() => {
          handleInStockChange(!Boolean(inStock));
        }}
        {...(inStock && {
          color: "primary",
          onDelete: () => {
            handleInStockChange(!Boolean(inStock));
          },
        })}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2"> کالاهای موجود</Typography>
          </Box>
        }
      ></Chip>
    </>
  );
}
